export default function TypeAheadRailBaseController(
    $scope,
    railsApiService,
) {
    'ngInject';

    $scope.railStations = [];

    $scope.getLocation = function(searchString) {
        $scope.railStations = [];

        if (searchString && searchString.length < 2) {
            return $scope.railStations;
        }

        /**
         * Expected request data
         */
        const requestData = {
            params: {searchPattern: searchString},
            noSpinner: true,
        };

        return railsApiService.searchLocation(requestData).then(function(response) {
            return response.data;
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/typeaheadRailBaseCtrl.js